import { css } from '@emotion/react';

export const headingStyles = ({ textTransform }) => css`
  text-transform: ${textTransform};
`;
